unit View.Parceiros.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewParceirosEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbendereco: TLabel;
    edendereco: TDBEdit;
    lbcomplemento: TLabel;
    edcomplemento: TDBEdit;
    lbbairro: TLabel;
    edbairro: TDBEdit;
    lbcep: TLabel;
    edcep: TDBEdit;
    lbtelefone1: TLabel;
    edtelefone1: TDBEdit;
    lbtelefone2: TLabel;
    edtelefone2: TDBEdit;
    lbcelular: TLabel;
    edcelular: TDBEdit;
    lbemail: TLabel;
    edemail: TDBEdit;
    lbsite: TLabel;
    edsite: TDBEdit;
    lbresponsavel: TLabel;
    edresponsavel: TDBEdit;
    lbcidade_id: TLabel;
    edcidade_id: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientParceirosGet: TXDataWebClient;
    XDataClientParceirosDelete: TXDataWebClient;
    ParceirosDataset: TXDataWebDataSet;
    ParceirosDatasetid: TIntegerField;
    ParceirosDatasetnome: TStringField;
    ParceirosDatasetendereco: TStringField;
    ParceirosDatasetcomplemento: TStringField;
    ParceirosDatasetbairro: TStringField;
    ParceirosDatasetcep: TStringField;
    ParceirosDatasettelefone1: TStringField;
    ParceirosDatasettelefone2: TStringField;
    ParceirosDatasetcelular: TStringField;
    ParceirosDatasetemail: TStringField;
    ParceirosDatasetsite: TStringField;
    ParceirosDatasetresponsavel: TStringField;
    ParceirosDatasetcidade_id: TIntegerField;
    ParceirosDatasetexcluido: TBooleanField;
    ParceirosDatasetinclusao: TDateTimeField;
    ParceirosDatasetalteracao: TDateTimeField;
    ParceirosDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientParceirosGetLoad(Response: TXDataClientResponse);
    procedure XDataClientParceirosDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientParceirosDeleteError(Error: TXDataClientError);
    procedure ParceirosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewParceirosEdit: TFViewParceirosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewParceirosEdit }

procedure TFViewParceirosEdit.btSaveClick(Sender: TObject);
begin
  if ParceirosDataset.State in dsEditModes then
  begin
        ParceirosDataset.Post;
    ParceirosDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewParceirosEdit.btDeleteClick(Sender: TObject);
begin
  if ParceirosDataset.State in dsEditModes then
    ParceirosDataset.Post;
  XDataClientParceirosDelete.Delete(ParceirosDataset.EntitySetName,
    TJSObject(ParceirosDataset.CurrentData));
end;


class function TFViewParceirosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewParceirosEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewParceirosEdit.InsertEntity;
begin
  ParceirosDataset.Close;
  ParceirosDataset.SetJsonData('{}');
  ParceirosDataset.Open;
  ParceirosDataset.Insert;
end;

class function TFViewParceirosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewParceirosEdit(AForm).FInserting := AInserting;
    TFViewParceirosEdit(AForm).FId := AId;
    TFViewParceirosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewParceirosEdit(AForm).InsertEntity
    else
      TFViewParceirosEdit(AForm).LoadEntity;
    TFViewParceirosEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewParceirosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewParceirosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    ParceirosDataset.Connection.Model.DefaultSchema.FindEntityType(
      ParceirosDataset.EntitySetName
    )
  );
  XDataClientParceirosGet.Get(ParceirosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewParceirosEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewParceirosEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewParceirosEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewParceirosEdit.XDataClientParceirosGetLoad(Response: TXDataClientResponse);
begin
  ParceirosDataset.Close;
  ParceirosDataset.SetJsonData(Response.Result);
  ParceirosDataset.Open;
  
  ParceirosDataset.Edit;  
end;

procedure TFViewParceirosEdit.XDataClientParceirosDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewParceirosEdit.XDataClientParceirosDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewParceirosEdit.ParceirosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewParceirosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewParceirosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.parceiros.form.message');
  lbMessage := TLabel.Create('view.parceiros.form.message.label');
  btCloseMessage := TButton.Create('view.parceiros.form.message.button');
  btCancel := TButton.Create('view.parceiros.form.btBack');
  btSave := TButton.Create('view.parceiros.form.btSave');
  btDelete := TButton.Create('view.parceiros.form.btDelete');
  lbid := TLabel.Create('view.parceiros.form.lbid');
  edid := TDBEdit.Create('view.parceiros.form.edid');
  lbnome := TLabel.Create('view.parceiros.form.lbnome');
  ednome := TDBEdit.Create('view.parceiros.form.ednome');
  lbendereco := TLabel.Create('view.parceiros.form.lbendereco');
  edendereco := TDBEdit.Create('view.parceiros.form.edendereco');
  lbcomplemento := TLabel.Create('view.parceiros.form.lbcomplemento');
  edcomplemento := TDBEdit.Create('view.parceiros.form.edcomplemento');
  lbbairro := TLabel.Create('view.parceiros.form.lbbairro');
  edbairro := TDBEdit.Create('view.parceiros.form.edbairro');
  lbcep := TLabel.Create('view.parceiros.form.lbcep');
  edcep := TDBEdit.Create('view.parceiros.form.edcep');
  lbtelefone1 := TLabel.Create('view.parceiros.form.lbtelefone1');
  edtelefone1 := TDBEdit.Create('view.parceiros.form.edtelefone1');
  lbtelefone2 := TLabel.Create('view.parceiros.form.lbtelefone2');
  edtelefone2 := TDBEdit.Create('view.parceiros.form.edtelefone2');
  lbcelular := TLabel.Create('view.parceiros.form.lbcelular');
  edcelular := TDBEdit.Create('view.parceiros.form.edcelular');
  lbemail := TLabel.Create('view.parceiros.form.lbemail');
  edemail := TDBEdit.Create('view.parceiros.form.edemail');
  lbsite := TLabel.Create('view.parceiros.form.lbsite');
  edsite := TDBEdit.Create('view.parceiros.form.edsite');
  lbresponsavel := TLabel.Create('view.parceiros.form.lbresponsavel');
  edresponsavel := TDBEdit.Create('view.parceiros.form.edresponsavel');
  lbcidade_id := TLabel.Create('view.parceiros.form.lbcidade_id');
  edcidade_id := TDBEdit.Create('view.parceiros.form.edcidade_id');
  lbexcluido := TLabel.Create('view.parceiros.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.parceiros.form.edexcluido');
  lbinclusao := TLabel.Create('view.parceiros.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.parceiros.form.edinclusao');
  lbalteracao := TLabel.Create('view.parceiros.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.parceiros.form.edalteracao');
  lbexclusao := TLabel.Create('view.parceiros.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.parceiros.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  ParceirosDataset := TXDataWebDataSet.Create(Self);
  ParceirosDatasetid := TIntegerField.Create(Self);
  ParceirosDatasetnome := TStringField.Create(Self);
  ParceirosDatasetendereco := TStringField.Create(Self);
  ParceirosDatasetcomplemento := TStringField.Create(Self);
  ParceirosDatasetbairro := TStringField.Create(Self);
  ParceirosDatasetcep := TStringField.Create(Self);
  ParceirosDatasettelefone1 := TStringField.Create(Self);
  ParceirosDatasettelefone2 := TStringField.Create(Self);
  ParceirosDatasetcelular := TStringField.Create(Self);
  ParceirosDatasetemail := TStringField.Create(Self);
  ParceirosDatasetsite := TStringField.Create(Self);
  ParceirosDatasetresponsavel := TStringField.Create(Self);
  ParceirosDatasetcidade_id := TIntegerField.Create(Self);
  ParceirosDatasetexcluido := TBooleanField.Create(Self);
  ParceirosDatasetinclusao := TDateTimeField.Create(Self);
  ParceirosDatasetalteracao := TDateTimeField.Create(Self);
  ParceirosDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientParceirosGet := TXDataWebClient.Create(Self);
  XDataClientParceirosDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbendereco.BeforeLoadDFMValues;
  edendereco.BeforeLoadDFMValues;
  lbcomplemento.BeforeLoadDFMValues;
  edcomplemento.BeforeLoadDFMValues;
  lbbairro.BeforeLoadDFMValues;
  edbairro.BeforeLoadDFMValues;
  lbcep.BeforeLoadDFMValues;
  edcep.BeforeLoadDFMValues;
  lbtelefone1.BeforeLoadDFMValues;
  edtelefone1.BeforeLoadDFMValues;
  lbtelefone2.BeforeLoadDFMValues;
  edtelefone2.BeforeLoadDFMValues;
  lbcelular.BeforeLoadDFMValues;
  edcelular.BeforeLoadDFMValues;
  lbemail.BeforeLoadDFMValues;
  edemail.BeforeLoadDFMValues;
  lbsite.BeforeLoadDFMValues;
  edsite.BeforeLoadDFMValues;
  lbresponsavel.BeforeLoadDFMValues;
  edresponsavel.BeforeLoadDFMValues;
  lbcidade_id.BeforeLoadDFMValues;
  edcidade_id.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  ParceirosDataset.BeforeLoadDFMValues;
  ParceirosDatasetid.BeforeLoadDFMValues;
  ParceirosDatasetnome.BeforeLoadDFMValues;
  ParceirosDatasetendereco.BeforeLoadDFMValues;
  ParceirosDatasetcomplemento.BeforeLoadDFMValues;
  ParceirosDatasetbairro.BeforeLoadDFMValues;
  ParceirosDatasetcep.BeforeLoadDFMValues;
  ParceirosDatasettelefone1.BeforeLoadDFMValues;
  ParceirosDatasettelefone2.BeforeLoadDFMValues;
  ParceirosDatasetcelular.BeforeLoadDFMValues;
  ParceirosDatasetemail.BeforeLoadDFMValues;
  ParceirosDatasetsite.BeforeLoadDFMValues;
  ParceirosDatasetresponsavel.BeforeLoadDFMValues;
  ParceirosDatasetcidade_id.BeforeLoadDFMValues;
  ParceirosDatasetexcluido.BeforeLoadDFMValues;
  ParceirosDatasetinclusao.BeforeLoadDFMValues;
  ParceirosDatasetalteracao.BeforeLoadDFMValues;
  ParceirosDatasetexclusao.BeforeLoadDFMValues;
  XDataClientParceirosGet.BeforeLoadDFMValues;
  XDataClientParceirosDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewParceirosEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 724;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 664;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 664;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 664;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 219;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 216;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 7;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbendereco.SetParentComponent(Self);
    lbendereco.Name := 'lbendereco';
    lbendereco.Left := 24;
    lbendereco.Top := 246;
    lbendereco.Width := 14;
    lbendereco.Height := 13;
    lbendereco.Caption := 'endereco:';
    lbendereco.Transparent := True;
    edendereco.SetParentComponent(Self);
    edendereco.Name := 'edendereco';
    edendereco.Left := 221;
    edendereco.Top := 243;
    edendereco.Width := 200;
    edendereco.Height := 21;
    edendereco.Enabled := True;
    edendereco.TabOrder := 8;
    edendereco.Text := 'edendereco';
    edendereco.DataField := 'endereco';
    edendereco.DataSource := DataSource;
    lbcomplemento.SetParentComponent(Self);
    lbcomplemento.Name := 'lbcomplemento';
    lbcomplemento.Left := 24;
    lbcomplemento.Top := 273;
    lbcomplemento.Width := 14;
    lbcomplemento.Height := 13;
    lbcomplemento.Caption := 'complemento:';
    lbcomplemento.Transparent := True;
    edcomplemento.SetParentComponent(Self);
    edcomplemento.Name := 'edcomplemento';
    edcomplemento.Left := 221;
    edcomplemento.Top := 270;
    edcomplemento.Width := 200;
    edcomplemento.Height := 21;
    edcomplemento.Enabled := True;
    edcomplemento.TabOrder := 9;
    edcomplemento.Text := 'edcomplemento';
    edcomplemento.DataField := 'complemento';
    edcomplemento.DataSource := DataSource;
    lbbairro.SetParentComponent(Self);
    lbbairro.Name := 'lbbairro';
    lbbairro.Left := 24;
    lbbairro.Top := 300;
    lbbairro.Width := 14;
    lbbairro.Height := 13;
    lbbairro.Caption := 'bairro:';
    lbbairro.Transparent := True;
    edbairro.SetParentComponent(Self);
    edbairro.Name := 'edbairro';
    edbairro.Left := 221;
    edbairro.Top := 297;
    edbairro.Width := 200;
    edbairro.Height := 21;
    edbairro.Enabled := True;
    edbairro.TabOrder := 10;
    edbairro.Text := 'edbairro';
    edbairro.DataField := 'bairro';
    edbairro.DataSource := DataSource;
    lbcep.SetParentComponent(Self);
    lbcep.Name := 'lbcep';
    lbcep.Left := 24;
    lbcep.Top := 327;
    lbcep.Width := 14;
    lbcep.Height := 13;
    lbcep.Caption := 'cep:';
    lbcep.Transparent := True;
    edcep.SetParentComponent(Self);
    edcep.Name := 'edcep';
    edcep.Left := 221;
    edcep.Top := 324;
    edcep.Width := 200;
    edcep.Height := 21;
    edcep.Enabled := True;
    edcep.TabOrder := 11;
    edcep.Text := 'edcep';
    edcep.DataField := 'cep';
    edcep.DataSource := DataSource;
    lbtelefone1.SetParentComponent(Self);
    lbtelefone1.Name := 'lbtelefone1';
    lbtelefone1.Left := 24;
    lbtelefone1.Top := 354;
    lbtelefone1.Width := 14;
    lbtelefone1.Height := 13;
    lbtelefone1.Caption := 'telefone1:';
    lbtelefone1.Transparent := True;
    edtelefone1.SetParentComponent(Self);
    edtelefone1.Name := 'edtelefone1';
    edtelefone1.Left := 221;
    edtelefone1.Top := 351;
    edtelefone1.Width := 200;
    edtelefone1.Height := 21;
    edtelefone1.Enabled := True;
    edtelefone1.TabOrder := 12;
    edtelefone1.Text := 'edtelefone1';
    edtelefone1.DataField := 'telefone1';
    edtelefone1.DataSource := DataSource;
    lbtelefone2.SetParentComponent(Self);
    lbtelefone2.Name := 'lbtelefone2';
    lbtelefone2.Left := 24;
    lbtelefone2.Top := 381;
    lbtelefone2.Width := 14;
    lbtelefone2.Height := 13;
    lbtelefone2.Caption := 'telefone2:';
    lbtelefone2.Transparent := True;
    edtelefone2.SetParentComponent(Self);
    edtelefone2.Name := 'edtelefone2';
    edtelefone2.Left := 221;
    edtelefone2.Top := 378;
    edtelefone2.Width := 200;
    edtelefone2.Height := 21;
    edtelefone2.Enabled := True;
    edtelefone2.TabOrder := 13;
    edtelefone2.Text := 'edtelefone2';
    edtelefone2.DataField := 'telefone2';
    edtelefone2.DataSource := DataSource;
    lbcelular.SetParentComponent(Self);
    lbcelular.Name := 'lbcelular';
    lbcelular.Left := 24;
    lbcelular.Top := 408;
    lbcelular.Width := 14;
    lbcelular.Height := 13;
    lbcelular.Caption := 'celular:';
    lbcelular.Transparent := True;
    edcelular.SetParentComponent(Self);
    edcelular.Name := 'edcelular';
    edcelular.Left := 221;
    edcelular.Top := 405;
    edcelular.Width := 200;
    edcelular.Height := 21;
    edcelular.Enabled := True;
    edcelular.TabOrder := 14;
    edcelular.Text := 'edcelular';
    edcelular.DataField := 'celular';
    edcelular.DataSource := DataSource;
    lbemail.SetParentComponent(Self);
    lbemail.Name := 'lbemail';
    lbemail.Left := 24;
    lbemail.Top := 435;
    lbemail.Width := 14;
    lbemail.Height := 13;
    lbemail.Caption := 'email:';
    lbemail.Transparent := True;
    edemail.SetParentComponent(Self);
    edemail.Name := 'edemail';
    edemail.Left := 221;
    edemail.Top := 432;
    edemail.Width := 200;
    edemail.Height := 21;
    edemail.Enabled := True;
    edemail.TabOrder := 15;
    edemail.Text := 'edemail';
    edemail.DataField := 'email';
    edemail.DataSource := DataSource;
    lbsite.SetParentComponent(Self);
    lbsite.Name := 'lbsite';
    lbsite.Left := 24;
    lbsite.Top := 462;
    lbsite.Width := 14;
    lbsite.Height := 13;
    lbsite.Caption := 'site:';
    lbsite.Transparent := True;
    edsite.SetParentComponent(Self);
    edsite.Name := 'edsite';
    edsite.Left := 221;
    edsite.Top := 459;
    edsite.Width := 200;
    edsite.Height := 21;
    edsite.Enabled := True;
    edsite.TabOrder := 16;
    edsite.Text := 'edsite';
    edsite.DataField := 'site';
    edsite.DataSource := DataSource;
    lbresponsavel.SetParentComponent(Self);
    lbresponsavel.Name := 'lbresponsavel';
    lbresponsavel.Left := 24;
    lbresponsavel.Top := 489;
    lbresponsavel.Width := 14;
    lbresponsavel.Height := 13;
    lbresponsavel.Caption := 'responsavel:';
    lbresponsavel.Transparent := True;
    edresponsavel.SetParentComponent(Self);
    edresponsavel.Name := 'edresponsavel';
    edresponsavel.Left := 221;
    edresponsavel.Top := 486;
    edresponsavel.Width := 200;
    edresponsavel.Height := 21;
    edresponsavel.Enabled := True;
    edresponsavel.TabOrder := 17;
    edresponsavel.Text := 'edresponsavel';
    edresponsavel.DataField := 'responsavel';
    edresponsavel.DataSource := DataSource;
    lbcidade_id.SetParentComponent(Self);
    lbcidade_id.Name := 'lbcidade_id';
    lbcidade_id.Left := 24;
    lbcidade_id.Top := 516;
    lbcidade_id.Width := 14;
    lbcidade_id.Height := 13;
    lbcidade_id.Caption := 'cidade_id:';
    lbcidade_id.Transparent := True;
    edcidade_id.SetParentComponent(Self);
    edcidade_id.Name := 'edcidade_id';
    edcidade_id.Left := 221;
    edcidade_id.Top := 513;
    edcidade_id.Width := 200;
    edcidade_id.Height := 21;
    edcidade_id.Enabled := True;
    edcidade_id.TabOrder := 18;
    edcidade_id.Text := 'edcidade_id';
    edcidade_id.DataField := 'cidade_id';
    edcidade_id.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 543;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 540;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 19;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 570;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 567;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 20;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 597;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 594;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 21;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 624;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 621;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 22;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := ParceirosDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    ParceirosDataset.SetParentComponent(Self);
    ParceirosDataset.Name := 'ParceirosDataset';
    ParceirosDataset.AfterApplyUpdates := ParceirosDatasetAfterApplyUpdates;
    ParceirosDataset.EntitySetName := 'Parceiros';
    ParceirosDataset.Connection := DMConnection.ApiConnection;
    ParceirosDataset.Left := 176;
    ParceirosDataset.Top := 8;
    ParceirosDatasetid.SetParentComponent(ParceirosDataset);
    ParceirosDatasetid.Name := 'ParceirosDatasetid';
    ParceirosDatasetid.FieldName := 'id';
    ParceirosDatasetid.Required := True;
    ParceirosDatasetnome.SetParentComponent(ParceirosDataset);
    ParceirosDatasetnome.Name := 'ParceirosDatasetnome';
    ParceirosDatasetnome.FieldName := 'nome';
    ParceirosDatasetnome.Required := False;
    ParceirosDatasetnome.Size := 255;
    ParceirosDatasetendereco.SetParentComponent(ParceirosDataset);
    ParceirosDatasetendereco.Name := 'ParceirosDatasetendereco';
    ParceirosDatasetendereco.FieldName := 'endereco';
    ParceirosDatasetendereco.Required := False;
    ParceirosDatasetendereco.Size := 255;
    ParceirosDatasetcomplemento.SetParentComponent(ParceirosDataset);
    ParceirosDatasetcomplemento.Name := 'ParceirosDatasetcomplemento';
    ParceirosDatasetcomplemento.FieldName := 'complemento';
    ParceirosDatasetcomplemento.Required := False;
    ParceirosDatasetcomplemento.Size := 255;
    ParceirosDatasetbairro.SetParentComponent(ParceirosDataset);
    ParceirosDatasetbairro.Name := 'ParceirosDatasetbairro';
    ParceirosDatasetbairro.FieldName := 'bairro';
    ParceirosDatasetbairro.Required := False;
    ParceirosDatasetbairro.Size := 255;
    ParceirosDatasetcep.SetParentComponent(ParceirosDataset);
    ParceirosDatasetcep.Name := 'ParceirosDatasetcep';
    ParceirosDatasetcep.FieldName := 'cep';
    ParceirosDatasetcep.Required := False;
    ParceirosDatasetcep.Size := 255;
    ParceirosDatasettelefone1.SetParentComponent(ParceirosDataset);
    ParceirosDatasettelefone1.Name := 'ParceirosDatasettelefone1';
    ParceirosDatasettelefone1.FieldName := 'telefone1';
    ParceirosDatasettelefone1.Required := False;
    ParceirosDatasettelefone1.Size := 255;
    ParceirosDatasettelefone2.SetParentComponent(ParceirosDataset);
    ParceirosDatasettelefone2.Name := 'ParceirosDatasettelefone2';
    ParceirosDatasettelefone2.FieldName := 'telefone2';
    ParceirosDatasettelefone2.Required := False;
    ParceirosDatasettelefone2.Size := 255;
    ParceirosDatasetcelular.SetParentComponent(ParceirosDataset);
    ParceirosDatasetcelular.Name := 'ParceirosDatasetcelular';
    ParceirosDatasetcelular.FieldName := 'celular';
    ParceirosDatasetcelular.Required := False;
    ParceirosDatasetcelular.Size := 255;
    ParceirosDatasetemail.SetParentComponent(ParceirosDataset);
    ParceirosDatasetemail.Name := 'ParceirosDatasetemail';
    ParceirosDatasetemail.FieldName := 'email';
    ParceirosDatasetemail.Required := False;
    ParceirosDatasetemail.Size := 255;
    ParceirosDatasetsite.SetParentComponent(ParceirosDataset);
    ParceirosDatasetsite.Name := 'ParceirosDatasetsite';
    ParceirosDatasetsite.FieldName := 'site';
    ParceirosDatasetsite.Required := False;
    ParceirosDatasetsite.Size := 255;
    ParceirosDatasetresponsavel.SetParentComponent(ParceirosDataset);
    ParceirosDatasetresponsavel.Name := 'ParceirosDatasetresponsavel';
    ParceirosDatasetresponsavel.FieldName := 'responsavel';
    ParceirosDatasetresponsavel.Required := False;
    ParceirosDatasetresponsavel.Size := 255;
    ParceirosDatasetcidade_id.SetParentComponent(ParceirosDataset);
    ParceirosDatasetcidade_id.Name := 'ParceirosDatasetcidade_id';
    ParceirosDatasetcidade_id.FieldName := 'cidade_id';
    ParceirosDatasetcidade_id.Required := False;
    ParceirosDatasetexcluido.SetParentComponent(ParceirosDataset);
    ParceirosDatasetexcluido.Name := 'ParceirosDatasetexcluido';
    ParceirosDatasetexcluido.FieldName := 'excluido';
    ParceirosDatasetexcluido.Required := False;
    ParceirosDatasetinclusao.SetParentComponent(ParceirosDataset);
    ParceirosDatasetinclusao.Name := 'ParceirosDatasetinclusao';
    ParceirosDatasetinclusao.FieldName := 'inclusao';
    ParceirosDatasetinclusao.Required := False;
    ParceirosDatasetalteracao.SetParentComponent(ParceirosDataset);
    ParceirosDatasetalteracao.Name := 'ParceirosDatasetalteracao';
    ParceirosDatasetalteracao.FieldName := 'alteracao';
    ParceirosDatasetalteracao.Required := False;
    ParceirosDatasetexclusao.SetParentComponent(ParceirosDataset);
    ParceirosDatasetexclusao.Name := 'ParceirosDatasetexclusao';
    ParceirosDatasetexclusao.FieldName := 'exclusao';
    ParceirosDatasetexclusao.Required := False;
    XDataClientParceirosGet.SetParentComponent(Self);
    XDataClientParceirosGet.Name := 'XDataClientParceirosGet';
    XDataClientParceirosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientParceirosGet, Self, 'OnLoad', 'XDataClientParceirosGetLoad');
    XDataClientParceirosGet.Left := 64;
    XDataClientParceirosGet.Top := 8;
    XDataClientParceirosDelete.SetParentComponent(Self);
    XDataClientParceirosDelete.Name := 'XDataClientParceirosDelete';
    XDataClientParceirosDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientParceirosDelete, Self, 'OnLoad', 'XDataClientParceirosDeleteLoad');
    SetEvent(XDataClientParceirosDelete, Self, 'OnError', 'XDataClientParceirosDeleteError');
    XDataClientParceirosDelete.Left := 64;
    XDataClientParceirosDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbendereco.AfterLoadDFMValues;
    edendereco.AfterLoadDFMValues;
    lbcomplemento.AfterLoadDFMValues;
    edcomplemento.AfterLoadDFMValues;
    lbbairro.AfterLoadDFMValues;
    edbairro.AfterLoadDFMValues;
    lbcep.AfterLoadDFMValues;
    edcep.AfterLoadDFMValues;
    lbtelefone1.AfterLoadDFMValues;
    edtelefone1.AfterLoadDFMValues;
    lbtelefone2.AfterLoadDFMValues;
    edtelefone2.AfterLoadDFMValues;
    lbcelular.AfterLoadDFMValues;
    edcelular.AfterLoadDFMValues;
    lbemail.AfterLoadDFMValues;
    edemail.AfterLoadDFMValues;
    lbsite.AfterLoadDFMValues;
    edsite.AfterLoadDFMValues;
    lbresponsavel.AfterLoadDFMValues;
    edresponsavel.AfterLoadDFMValues;
    lbcidade_id.AfterLoadDFMValues;
    edcidade_id.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    ParceirosDataset.AfterLoadDFMValues;
    ParceirosDatasetid.AfterLoadDFMValues;
    ParceirosDatasetnome.AfterLoadDFMValues;
    ParceirosDatasetendereco.AfterLoadDFMValues;
    ParceirosDatasetcomplemento.AfterLoadDFMValues;
    ParceirosDatasetbairro.AfterLoadDFMValues;
    ParceirosDatasetcep.AfterLoadDFMValues;
    ParceirosDatasettelefone1.AfterLoadDFMValues;
    ParceirosDatasettelefone2.AfterLoadDFMValues;
    ParceirosDatasetcelular.AfterLoadDFMValues;
    ParceirosDatasetemail.AfterLoadDFMValues;
    ParceirosDatasetsite.AfterLoadDFMValues;
    ParceirosDatasetresponsavel.AfterLoadDFMValues;
    ParceirosDatasetcidade_id.AfterLoadDFMValues;
    ParceirosDatasetexcluido.AfterLoadDFMValues;
    ParceirosDatasetinclusao.AfterLoadDFMValues;
    ParceirosDatasetalteracao.AfterLoadDFMValues;
    ParceirosDatasetexclusao.AfterLoadDFMValues;
    XDataClientParceirosGet.AfterLoadDFMValues;
    XDataClientParceirosDelete.AfterLoadDFMValues;
  end;
end;

end.
